import { render, staticRenderFns } from "./EditarCronograma.vue?vue&type=template&id=0fb617ef"
import script from "./EditarCronograma.vue?vue&type=script&lang=js"
export * from "./EditarCronograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports